import { lazy } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";

import adminRoutes from "./admin";
import agentRoutes from "./agent";

import ProtectedAdminRoute from "@/components/ProtectedRoutes/ProtectedAdminRoute";
import ProtectedRoute from "@/components/ProtectedRoutes/ProtectedRoute";
import RootLayout from "@/layouts/RootLayout";
import { ADMIN_ROUTE_PREFIX } from "@/types/constants/common";

const Login = lazy(() => import("@/pages/auth/Login/Login"));
const FreshdeskLogin = lazy(() => import("@/pages/auth/FreshdeskLogin/FreshdeskLogin"));
const AgentLayout = lazy(() => import("@/layouts/AgentLayout"));
const AdminLayout = lazy(() => import("@/layouts/AdminLayout"));
const Error404 = lazy(() => import("@/pages/Error404"));
const AdminError404 = lazy(() => import("@/pages/AdminError404"));
const ErrorPage = lazy(() => import("@/pages/ErrorPage"));

const router = createBrowserRouter([
  {
    errorElement: <ErrorPage />, // global error page, for errors in login, agentLayout, adminLayout
    children: [
      {
        path: "auth/login",
        element: <Login />,
      },
      {
        // password reset is part of the Clerk sign-in flow
        path: "auth/forgot-password",
        element: <Navigate to={"/auth/login"} replace />,
      },
      {
        // Freshdesk SSO entry point, outside RootLayout so no Hub chrome loads before the redirect
        path: "auth/freshdesk",
        element: (
          <ProtectedRoute>
            <FreshdeskLogin />
          </ProtectedRoute>
        ),
      },
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <RootLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            path: "/",
            element: <AgentLayout />,
            children: [
              {
                errorElement: <ErrorPage />,
                children: agentRoutes,
              },
              {
                path: "404",
                element: <Error404 />,
              },
              {
                path: "*",
                element: <Error404 />,
              },
            ],
          },
          {
            path: ADMIN_ROUTE_PREFIX,
            element: (
              <ProtectedAdminRoute>
                <AdminLayout />
              </ProtectedAdminRoute>
            ),
            children: [
              {
                errorElement: <ErrorPage />,
                children: adminRoutes,
              },
              {
                path: "404",
                element: <AdminError404 />,
              },
              {
                path: "*",
                element: <AdminError404 />,
              },
            ],
          },
        ],
      },
      {
        path: "*",
        element: <Error404 />,
      },
    ],
  },
]);

export default router;
